import * as React from 'react';
import { OUTPUT_DROPDOWN_DEFAULT } from '../../constants';
import { IBranch, IOperator, IConditionConfig } from '../../helpers';
import {
	Button, ButtonType, IDropdownOption, Label
} from 'office-ui-fabric-react';
import types from '../../store/types';

interface IProps {
	branch: IBranch;
	operators: IOperator[];
	operatorTypes: string[];
	index: number;
	outputOptions: IDropdownOption[];
	canDeleteBranch: boolean;
	setBranchEditIndex: (branchEditIndex: number) => void;
	deleteBranch: (index: number) => void;
	closeDialog?: (save?: boolean) => void;
	changeShowBranchEdit?: (val?: boolean) => void;
	toggleDecisionConfigDialog?: (componentId: string, previousOutputBlocks: any) => void;
	componentId?: string;
	previousOutputBlocks?: any;

}

export class Branch extends React.Component<IProps, any> {

	constructor(props: any) {
		super(props);
	};

	public render() {

		let {
			operators, branch, index, deleteBranch,
			outputOptions, canDeleteBranch, setBranchEditIndex,
			toggleDecisionConfigDialog, componentId, previousOutputBlocks,
			changeShowBranchEdit
		} = this.props;

		let operatorDropdownOptions: IDropdownOption[] = operators.map((v, i) => {
			let d: IDropdownOption = {
				key: v.Id,
				index: i,
				text: v.Name
			};
			return d;
		});

		//add blank option to the top of dropdownOptions
		let queryBuilderOutputOptions: IDropdownOption[] = [OUTPUT_DROPDOWN_DEFAULT];
		queryBuilderOutputOptions = queryBuilderOutputOptions.concat(outputOptions);

		return (
			<div>
				<Label className='h4'>
					{/* {branch.Name} */}
					{'Edit condition '}
					<Button
						className='branch-edit-button'
						buttonType={ButtonType.icon}
						icon='Edit'
						onClick={() => {
							toggleDecisionConfigDialog(componentId, previousOutputBlocks);
							changeShowBranchEdit(true);
							setBranchEditIndex(index);
						}}
					/>
					{canDeleteBranch ?
						<Button
							className='branch-delete-button'
							buttonType={ButtonType.icon}
							icon='Delete'
							onClick={(event) => {
								deleteBranch(index);
								event.stopPropagation();
							}}
						/> : null}
				</Label>
			</div>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/decisions/branch.tsx